/**
 * Serverity of the message
 * will be displayed as followed:
 * * info : blue
 * * success : green
 * * warn : yellow
 * * danger : red
 */
export class Severity {
    static INFO = 'info';
    static SUCCESS = 'success';
    static WARN = 'warn';
    static DANGER = 'error';
}
